export const isDev = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const isStage = process.env.NEXT_PUBLIC_API_DOMAIN === 'straus-delivery-hq18.eu.ngrok.io';

if (isDev) console.log('__DEV__', isDev, isStage);
